import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import { Formik, Form } from "formik";
import {
  InputValidationSm,
  Select,
  DatePickerX,
  SelectAsync,
  DropZone,
} from "view/component/FormFormik";
import apiService from "apiService";
import { showLoading, toast } from "view/component/Alert";
import moment from "moment";

const Sisroute = (props) => {
  const [state, setstate] = useState({
    nik: props.patient?.patients?.nik,
    jenis_rujukan: "2",
    pelayanan: "LY012",
    nomor_rujukan_bpjs: "",
    kriteria_rujukan: null,
    kriteria_khusus: null,
    sdm: null,
    kriteria_pelayanan: null,
    kelas_perawatan: null,
    jenis_perawatan: null,
    alat: "",
    sarana: null,
    kriteria_matneo: null,
    tanggal: new Date(),
    faskes_tujuan: "",
    alasan: "1",
    alasan_lainnya: "-",
    keadaan_umum: "-",
    nyeri: 0,
    alergi: "-",
  });
  const [Ref, setRef] = useState("");
  const [refFaskes, setFaskes] = useState("");
  const [kriteriaRujukan, setKriteriaRujukan] = useState(305);

  const getRef = async () => {
    let url = [
      "/sisrute/reference/go?url=rsonline/referensi/kategorilayanan",
      "/sisrute/reference/go?url=referensi/alasanrujukan",
      "/sisrute/reference/go?url=referensi/kriteria/rujukan?DIAGNOSA=" +
      props.patient?.diagnoses.filter((e) => e.log != true)[0]?.icd_code,
      "/sisrute/reference/go?url=referensi/kriteria/khusus",
      "/sisrute/reference/go?url=rsonline/referensi/sdm",
      "/sisrute/reference/go?url=referensi/kriteria/matneo?DIAGNOSA=" +
      props.patient?.diagnoses.filter((e) => e.log != true)[0]?.icd_code,
      "/sisrute/reference/go?url=rsonline/referensi/ruangperawatan?start=0&limit=10",
      "/sisrute/reference/go?url=rsonline/referensi/kelas",
      "/sisrute/reference/go?url=rsonline/referensi/sarana",
    ];
    let referensi = await apiService.getAll(url);
    if (referensi) {
      setRef({
        pelayanan: referensi[0]?.data?.data?.map((data) => {
          return { id: data.kode, name: data.layanan };
        }),
        alasan: referensi[1]?.data?.data?.map((data) => {
          return { id: data.KODE, name: data.NAMA };
        }),
        kriteria_rujukan: referensi[2]?.data?.data?.map((data) => {
          return { id: data.KODE, name: data.DESKRIPSI };
        }),
        kriteria_khusus: referensi[3]?.data?.data?.map((data) => {
          return { id: data.KODE, name: data.DESKRIPSI };
        }),
        sdm: referensi[4]?.data?.data?.map((data) => {
          return { id: data.kode, name: data.sdm };
        }),
        kriteria_matneo: referensi[5]?.data?.data?.map((data) => {
          return {
            id: data.KODE,
            name: `${data.DESKRIPSI} (${data.DESKRIPSI_KATEGORI})`,
          };
        }),
        ruang_perawatan: referensi[6]?.data?.data?.map((data) => {
          return { id: data.kode, name: data.kelas };
        }),
        kelas_perawatan: referensi[7]?.data?.data?.map((data) => {
          return { id: data.kode, name: data.nama };
        }),
        sarana: referensi[8]?.data?.data?.map((data) => {
          return { id: data.kode_sarana, name: data.sarana };
        }),
      });
    }
    console.log(referensi);
  };
  const getMatneo = async () => {
    let res = await apiService.get(
      "sisrute/reference/go?url=referensi/kriteria/matneo?DIAGNOSA=" +
      props.patient?.diagnoses.filter((e) => e.log != true)[0]?.icd_code
    );
    if (res.success) {
      setRef({
        ...Ref,
        kriteria_matneo: res.data?.map((data) => {
          return {
            id: data.KODE,
            name: `${data.DESKRIPSI} (${data.DESKRIPSI_KATEGORI})`,
          };
        }),
      });
    }
    console.log(res);
  };
  useEffect(() => {
    console.log(Ref);
  }, [Ref]);
  useEffect(() => {
    getRef();
    console.log(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
  }, [1]);
  const getRs = async () => {
    let data = [];
    let res = await apiService.get(
      "/sisrute/reference/go?url=referensi/faskes?query=" + refFaskes
    );
    res.data.map((dat) => {
      data.push({ value: dat.KODE, label: dat.NAMA });
    });
    return data;
  };
  const ChangeKriteria = (e) => {
    setKriteriaRujukan(e);
    if (e === 305) {
      setstate({
        ...state,
        kriteria_rujukan: "305",
        kriteria_khusus: null,
        sdm: null,
        kriteria_pelayanan: null,
        kelas_perawatan: null,
        jenis_perawatan: null,
        alat: null,
        sarana: null,
        kriteria_matneo: null,
      });
    } else if (e === 1) {
      setstate({
        ...state,
        kriteria_rujukan: "305",
        kriteria_khusus: "1",
        sdm: "01",
        kriteria_pelayanan: "XXI",
        kelas_perawatan: "1",
        jenis_perawatan: "21",
        alat: "AD",
        sarana: "1",
        kriteria_matneo: "14523",
      });
    } else {
      setstate({
        ...state,
        kriteria_rujukan: null,
        kriteria_khusus: null,
        sdm: null,
        kriteria_pelayanan: null,
        kelas_perawatan: null,
        jenis_perawatan: null,
        alat: null,
        sarana: null,
        kriteria_matneo: "14523",
      });
      getMatneo();
    }
  };
  useEffect(() => {
    console.log(props.image);
  }, [props.image.data]);
  return (
    <div>
      <Modal {...props} aria-labelledby="modal-user">
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Rujukan Sisroute</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            ...state,
          }}
          // validationSchema={SignupSchema}
          onSubmit={(values) => {
            props.change({
              ...state,
              tanggal: moment(state.tanggal).format("YYYY-MM-DD HH:mm:ss"),
              faskes_tujuan: state.faskes_tujuan.value,
            });
            props.onHide();
          }}
        >
          {({ errors, touched, values }) => (
            <Form className="col-md-12">
              <ModalBody>
                <Select
                  name="jenis_rujukan"
                  onChange={(e) =>
                    setstate({ ...state, jenis_rujukan: e.target.value })
                  }
                  value={values.jenis_rujukan}
                  placeholder="jenis_rujukan "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Jenis Rujukan"
                  option={[
                    { id: 1, name: "Rawat Jalan" },
                    { id: 2, name: "Rawat Darurat/Inap" },
                    { id: 3, name: "Parsial" },
                    { id: 6, name: "Maternal" },
                    { id: 7, name: "Neonatal" },
                  ]}
                />
                <Select
                  name="pelayanan"
                  onChange={(e) =>
                    setstate({ ...state, pelayanan: e.target.value })
                  }
                  value={values.pelayanan}
                  placeholder="pelayanan "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Pelayanan"
                  option={Ref.pelayanan ? Ref.pelayanan : []}
                />
                <InputValidationSm
                  name="nomor_rujukan_bpjs"
                  onChange={(e) =>
                    setstate({ ...state, nomor_rujukan_bpjs: e.target.value })
                  }
                  value={values.nomor_rujukan_bpjs}
                  placeholder="nomor_rujukan_bpjs "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="No Rujukan BPJS"
                />
                {state.jenis_rujukan == 1 ? (
                  <div>
                    <Select
                      name="kriteria_rujukan"
                      onChange={(e) => {
                        setstate({
                          ...state,
                          kriteria_rujukan: e.target.value,
                        });
                      }}
                      value={state.kriteria_rujukan}
                      placeholder="kriteria_rujukan"
                      errors={errors}
                      touched={touched}
                      icon="ni ni-circle-08"
                      type="text"
                      label="Kriteria rujukan"
                      option={Ref.kriteria_rujukan}
                    />
                    <Select
                      name="kriteria_khusus"
                      onChange={(e) =>
                        setstate({ ...state, kriteria_khusus: e.target.value })
                      }
                      value={values.kriteria_khusus}
                      placeholder="kriteria_khusus "
                      errors={errors}
                      touched={touched}
                      icon="ni ni-circle-08"
                      type="text"
                      label="Kriteria Khusus"
                      option={Ref.kriteria_khusus ? Ref.kriteria_khusus : []}
                    />
                    {state.kriteria_rujukan == null ? (
                      state.kriteria_khusus == null ? (
                        <div>
                          <Select
                            name="sdm"
                            onChange={(e) =>
                              setstate({ ...state, sdm: e.target.value })
                            }
                            value={values.sdm}
                            placeholder="sdm "
                            errors={errors}
                            touched={touched}
                            icon="ni ni-circle-08"
                            type="text"
                            label="SDM"
                            option={Ref.sdm ? Ref.sdm : []}
                          />
                          <Select
                            name="kriteria_pelayanan"
                            onChange={(e) =>
                              setstate({
                                ...state,
                                kriteria_pelayanan: e.target.value,
                              })
                            }
                            value={values.kriteria_pelayanan}
                            placeholder="kriteria_pelayanan "
                            errors={errors}
                            touched={touched}
                            icon="ni ni-circle-08"
                            type="text"
                            label="Kriteria Pelayanan"
                            option={[]}
                          />
                          <Select
                            name="kelas_perawatan"
                            onChange={(e) =>
                              setstate({
                                ...state,
                                kelas_perawatan: e.target.value,
                              })
                            }
                            value={values.kelas_perawatan}
                            placeholder="kelas_perawatan "
                            errors={errors}
                            touched={touched}
                            icon="ni ni-circle-08"
                            type="text"
                            label="Kelas Perawatan"
                            option={Ref.kelas_perawatan ? Ref.kelas_perawatan : []}
                          />
                          <Select
                            name="jenis_perawatan"
                            onChange={(e) =>
                              setstate({
                                ...state,
                                jenis_perawatan: e.target.value,
                              })
                            }
                            value={values.jenis_perawatan}
                            placeholder="jenis_perawatan "
                            errors={errors}
                            touched={touched}
                            icon="ni ni-circle-08"
                            type="text"
                            label="Jenis Perawatan"
                            option={[]}
                          />
                          <InputValidationSm
                            name="alat"
                            onChange={(e) =>
                              setstate({ ...state, alat: e.target.value })
                            }
                            value={values.alat}
                            placeholder="alat "
                            errors={errors}
                            touched={touched}
                            icon="ni ni-circle-08"
                            type="text"
                            label="ALat"
                          />
                          <Select
                            name="sarana"
                            onChange={(e) =>
                              setstate({ ...state, sarana: e.target.value })
                            }
                            value={values.sarana}
                            placeholder="sarana "
                            errors={errors}
                            touched={touched}
                            icon="ni ni-circle-08"
                            type="text"
                            label="Sarana"
                            option={Ref.sarana}
                          />
                        </div>
                      ) : (
                          ""
                        )
                    ) : (
                        ""
                      )}
                    <Select
                      name="kriteria_matneo"
                      onChange={(e) =>
                        setstate({ ...state, kriteria_matneo: e.target.value })
                      }
                      value={values.kriteria_matneo}
                      placeholder="kriteria_matneo "
                      errors={errors}
                      touched={touched}
                      icon="ni ni-circle-08"
                      type="text"
                      label="kriteria_matneo"
                      option={Ref.kriteria_matneo ? Ref.kriteria_matneo : []}
                    />
                  </div>
                ) : (
                    ""
                  )}
                <div className="form-group">
                  <div className="row col-md-12">
                    <div className="col-md-4">
                      <label className="form-control-label" htmlFor="tanggal">
                        Tanggal
                      </label>
                    </div>
                    <div className="col-md-8">
                      <DatePickerX
                        class="form-control form-control-sm col-md-12"
                        startDate={state.tanggal}
                        setStartDate={(e) => setstate({ ...state, tanggal: e })}
                      />
                    </div>
                  </div>
                </div>

                <SelectAsync
                  name="faskes_tujuan"
                  onInputChange={(e) => setFaskes(e)}
                  onChange={(e) => setstate({ ...state, faskes_tujuan: e })}
                  value={values.faskes_tujuan}
                  placeholder="faskes_tujuan"
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="faskes tujuan"
                  loadOptions={() => getRs()}
                />
                <Select
                  name="alasan"
                  onChange={(e) =>
                    setstate({ ...state, alasan: e.target.value })
                  }
                  value={values.alasan}
                  placeholder="alasan "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Alasan"
                  option={Ref.alasan}
                />
                <InputValidationSm
                  name="alasan_lainnya"
                  onChange={(e) =>
                    setstate({ ...state, alasan_lainnya: e.target.value })
                  }
                  value={values.alasan_lainnya}
                  placeholder="alasan_lainnya "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Alasan lainnya"
                />
                <InputValidationSm
                  name="keadaan_umum"
                  onChange={(e) =>
                    setstate({ ...state, keadaan_umum: e.target.value })
                  }
                  value={values.keadaan_umum}
                  placeholder="keadaan_umum "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Keadaan umum"
                  option={[]}
                />
                <Select
                  name="nyeri"
                  onChange={(e) =>
                    setstate({ ...state, nyeri: e.target.value })
                  }
                  value={values.nyeri}
                  placeholder="nyeri "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Nyeri"
                  option={[
                    { id: 0, name: "Tidak Nyeri" },
                    { id: 1, name: "Ringan" },
                    { id: 2, name: "Sedang" },
                    { id: 3, name: "Berat" },
                  ]}
                />
                <InputValidationSm
                  name="alergi"
                  onChange={(e) =>
                    setstate({ ...state, alergi: e.target.value })
                  }
                  value={values.alergi}
                  placeholder="Alergi "
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  type="text"
                  label="Alergi"
                />
                <DropZone
                  name="lab"
                  onChange={(e) =>
                    props.image.change(e)
                  }
                  value={props.image.data}
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  label="Lampiran Lab"
                />
                {/* <DropZone
                  name="RADIOLOGI"
                  onChange={(e) =>
                    props.image.change(e)
                  }
                  value={props.image.data}
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  label="Alergi"
                />
                <DropZone
                  name="EKG"
                  onChange={(e) =>
                    props.image.change(e)
                  }
                  value={props.image.data}
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  label="Alergi"
                /> */}
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  onClick={() => {
                    props.onHide();
                  }}
                  className="btn btn-secondary"
                >
                  Batal
                </button>
                <button type="submit" className="btn btn-primary">
                  Simpan Data
                </button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default Sisroute;
